
<div class="field-token-list">
  <!-- Search Header -->
  <div class="field-token-list__header">
    <div class="field-token-list__search">
      <v-text-field
        v-model="searchQuery"
        placeholder="Search fields..."
        prepend-inner-icon="mdi-magnify"
        clearable
        dense
        outlined
        hide-details
        :disabled="disabled"
      />
    </div>
  </div>

  <!-- Field List -->
  <div class="field-token-list__content">
    <div class="field-token-list__fields">
      <FieldItem
        v-for="field in filteredFields"
        :key="field.fieldName"
        :field="field"
        :disabled="disabled"
        :is-used="fieldUsageMap[field.fieldName] > 0"
        :usage-count="fieldUsageMap[field.fieldName] || 0"
        @click="handleFieldClick"
        @dragstart="handleDragStart"
        @dragend="handleDragEnd"
        v-bind="$attrs"
      />
    </div>

    <!-- No Results -->
    <div v-if="filteredFields.length === 0" class="field-token-list__empty">
      <v-icon color="grey" size="48">mdi-magnify</v-icon>
      <p class="text-caption text-center mt-2">
        No fields found matching "{{ searchQuery }}"
      </p>
    </div>
  </div>
</div>
